import { render, staticRenderFns } from "./shops-admin-view.vue?vue&type=template&id=3bef5152&scoped=true"
import script from "./shops-admin-view.vue?vue&type=script&lang=js"
export * from "./shops-admin-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef5152",
  null
  
)

export default component.exports